function maintHistReducer(state = [], action) {
    const { type, payload } = action;

    switch(type) {
        case "GET_MAINT_HISTORY_SUCCESS":
            let maint_hist = [];
            if(payload.page != 0)
                maint_hist = Object.assign([], state.maint_hist);
            maint_hist = maint_hist.concat(payload.response.docs);
            return Object.assign({}, state, { maint_hist });

        case "GET_MAINT_STEP_HISTORY_SUCCESS":
            let maint_step_hist = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { maint_step_hist });

        case "GET_MAINT_PART_HISTORY_SUCCESS":
            let maint_part_hist = [];
            if(payload.page != 0)
                maint_part_hist = Object.assign([], state.maint_part_hist);
            maint_part_hist = maint_part_hist.concat(payload.response.docs);
            return Object.assign({}, state, { maint_part_hist });

        case "GET_PART_HISTORY_SUCCESS":
            let part_history = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { part_history });

        case "UNSET_MAINT_HIST":
            return Object.assign({}, state, { equipment: {}, maint_hist: [], maint_step_hist: [] });

        default:
            return state;
    }
}

export default maintHistReducer;